/**
 * admin/tutors.tsx — Admin tutor management surface.
 *
 * Lives at `/admin/tutors`. Auth-gated to admins. Renders PageHeader +
 * <TutorCrudPanel> (Fase 2 N-08). Replaces the legacy TutorApprovalQueue.
 */

import type { ReactNode } from 'react';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { PageHeader } from '../../components/ui/PageHeader.js';
import TutorCrudPanel from '../../components/admin/TutorCrudPanel.js';
import { freshSessionQuery, tutorsListQuery } from '../../lib/api/queries.js';

export const Route = createFileRoute('/admin/tutors')({
  beforeLoad: async ({ context, location }) => {
    const session = await context.queryClient.fetchQuery(freshSessionQuery);
    const user = session?.ok ? (session.data?.user ?? null) : null;
    if (!user) {
      throw redirect({
        to: '/login',
        search: { error: undefined, redirect: location.href },
      });
    }
    if (user.role !== 'admin') {
      throw redirect({ to: '/' });
    }
    return null;
  },
  loader: async ({ context }) => {
    await context.queryClient.prefetchQuery(tutorsListQuery());
    return null;
  },
  component: AdminTutorsPage,
});

function AdminTutorsPage(): ReactNode {
  return (
    <main className="page-shell" data-testid="admin-tutors-page">
      <PageHeader
        eyebrow="Operasional"
        title="Manajemen tutor"
        description="Buat akun tutor baru, lihat daftar tutor, dan nonaktifkan tutor yang sudah tidak aktif. Tutor yang dinonaktifkan tidak bisa login."
      />
      <section className="section is-flush">
        <TutorCrudPanel />
      </section>
    </main>
  );
}
